import { Auth } from '../Auth';
import LocalStorageService from '../LocalStorageService';
import { ORDERS_VIEW_SUBJECTS, SETTINGS_VIEW_SUBJECTS } from '../../../config/constants';

// [CANA-577] Landing pages in left-menu order (useMenuDashBoard.js), each with the
// codename(s) its route is gated on in App.jsx. "/admin" is the menu: its index route
// forwards to /admin/menu/<first menu id>.
const LANDING_PAGES = [
    ['/admin', ['view_menu']],
    ['/admin/orders/all', ORDERS_VIEW_SUBJECTS.map((subject) => 'view_' + subject)],
    ['/admin/map', ['view_in_map']],
    ['/admin/promocodes', ['view_promocode']],
    ['/admin/patient', ['view_patient']],
    ['/admin/reports', ['view_report']],
    ['/admin/analytics', ['view_analytics']],
    ['/admin/generatedreports', ['view_generatedreport']],
    ['/admin/chat', ['view_aichat']],
    ['/admin/inventory', ['view_inventorytransaction']],
    ['/admin/team/drivers', ['view_driver']],
    ['/admin/settings', SETTINGS_VIEW_SUBJECTS.map((subject) => 'view_' + subject)],
];

const RolesHelper = {
    // First page the user may open; My Account needs no permission.
    getFirstAccessiblePage() {
        const { is_superuser, group_permissions = [] } = LocalStorageService.get('authorizationData') || {};
        if (is_superuser) {
            return '/admin';
        }
        const page = LANDING_PAGES.find(([, codenames]) =>
            codenames.some((codename) => group_permissions?.includes(codename))
        );
        return page ? page[0] : '/admin/myaccount';
    },
    getRedirectPage(url) {
        if(url) {
            return url;
        }
        if (Auth.isAuthenticated()) {
            return RolesHelper.getFirstAccessiblePage();
        } else {
            // loginState = false;
            return '/';
        }
    }
}

export default RolesHelper;
